/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import { reduxForm } from 'redux-form';

/* eslint-disable no-restricted-imports */
import { Grid } from '@material-ui/core';
import BaseComponent from '@tock/shared/components/BaseComponent';
import ButtonGroup from '@tock/shared/components/buttons/ButtonGroup';
import Fieldset from '@tock/shared/components/forms/Fieldset';
import Form from '@tock/shared/components/forms/Form';
import PriceInput from '@tock/shared/components/inputs/PriceInput';
import SubmitButton from '@tock/shared/components/buttons/SubmitButton';
import TextInput from '@tock/shared/components/inputs/DeprecatedTextInput';

interface Props {
  disabled?: boolean;
  giftCardRequestInProgress: boolean;
  hideAmountField?: boolean;
  requirePin: boolean;
  onSubmit(values: FormValues): void;
  onGiftCardChanged(values: any): void;
}

const validate = (values: FormValues, props: Props) => {
  const error: ReduxFormErrors<FormValues> = {};
  if (!values.cardNumber) {
    error.cardNumber = 'Please fill a valid gift card number';
  }

  if (!values.amountCents) {
    error.amountCents = 'Please fill a valid gift card amount';
  }
  if (props.requirePin && !values.cardPin?.trim()) {
    error.cardPin = 'Please fill a valid PIN';
  }

  return error;
};

interface FormValues {
  amountCents: number;
  cardNumber: string;
  cardPin: string;
}

class AddGiftCardForm extends BaseComponent<Props & ReduxFormProps<FormValues>> {
  handleSubmitHelper(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();
    this.props.handleSubmit();
  }

  render() {
    const {
      disabled,
      fields: { amountCents, cardNumber, cardPin },
      hideAmountField,
      pristine,
      requirePin,
      submitting,
    } = this.props;

    const disableButton = disabled || pristine || submitting;

    return (
      <Form modifierClassName="Form--default Form--no-padding" onSubmit={this.handleSubmitHelper}>
        <Fieldset>
          <Grid container spacing={2}>
            {!hideAmountField && (
              <Grid item xs={12}>
                <PriceInput
                  field={amountCents}
                  disabled={disabled}
                  onChange={this.props.onGiftCardChanged}
                />
              </Grid>
            )}

            <Grid item xs={12} sm={requirePin ? 6 : 12}>
              <TextInput
                field={cardNumber}
                disabled={disabled}
                maxLength={20}
                pattern="\d*"
                type="tel"
                placeholder="Enter your gift card #"
                onChange={this.props.onGiftCardChanged}
              />
            </Grid>

            {requirePin && (
              <Grid item xs={12} sm={6}>
                <TextInput
                  field={cardPin}
                  disabled={disabled}
                  pattern="\d*"
                  placeholder="Enter your gift card PIN"
                  onChange={this.props.onGiftCardChanged}
                />
              </Grid>
            )}
          </Grid>

          <ButtonGroup className="FormActions">
            <SubmitButton
              disabled={disableButton}
              submitting={this.props.giftCardRequestInProgress || submitting}
              size="medium"
              stretch
              variant="secondary"
            >
              Apply gift card
            </SubmitButton>
          </ButtonGroup>
        </Fieldset>
      </Form>
    );
  }
}

export default reduxForm<Props, FormValues>({
  form: 'AddGiftCardForm',
  fields: ['cardNumber', 'amountCents', 'cardPin'],
  validate,
  initialValues: {
    amountCents: 0,
  },
})(AddGiftCardForm);
